export default __webpack_public_path__ + "static/media/pin.f9700a28.png";